import { NavLink } from 'react-router';

import { FaIcon, NgNotificationBadge, TextWithIcon } from '@/ui';
import { DateFormatter } from '@/features/shared/DateFormatter';
import { incidentDetailRoute } from '@/features/shared/routes';
import { callDataSourceNames } from '@ngsos/portal-core/portal';
import type { PortalCall } from '@/signalr/contracts';

export type CallNotificationListComponentItemProps = {
  call: PortalCall;
  incidentId: string | null;
  onCreateNewIncident: (call: PortalCall) => void | Promise<void>;
};

const LINK_CSS_CLASS =
  'call-notification-item d-flex flex-row justify-content-between align-items-center border-bottom py-1 px-2 text-decoration-none';

export function CallNotificationListComponentItem({
  call,
  incidentId,
  onCreateNewIncident,
}: CallNotificationListComponentItemProps) {
  const phoneIcon = call.endTimeUtc != null ? 'fa-light fa-phone-hangup' : 'fa-light fa-phone-volume';
  const sourceNames = callDataSourceNames(call.sourceKinds);

  const content = (
    <div className="d-flex flex-column gap- align-items-stretch col-11">
      <TextWithIcon icon={phoneIcon} cssClass="d-flex align-items-center" contentCssClass="fw-bold">
        {call.callId}
      </TextWithIcon>
      {sourceNames.length > 0 && (
        <TextWithIcon icon="fa-light fa-circle-location-arrow">
          <span className="small d-inline-flex flex-wrap gap-1">
            {sourceNames.map((sourceName) => (
              <NgNotificationBadge key={sourceName} noMargin color="darkGray" text={sourceName} />
            ))}
          </span>
        </TextWithIcon>
      )}
      <TextWithIcon icon="fa-light fa-clock">
        <span className="small">
          <DateFormatter date={call.startTimeUtc} updateIntervalMs={1000} formatType="timeCombined" />
        </span>
      </TextWithIcon>
    </div>
  );

  return (
    <div className="call-notification-item-wrapper">
      {incidentId != null ? (
        <NavLink
          to={incidentDetailRoute(incidentId)}
          className={({ isActive }) => (isActive ? `${LINK_CSS_CLASS} active` : LINK_CSS_CLASS)}
        >
          {content}
          <FaIcon icon="fa-light fa-chevron-right" />
        </NavLink>
      ) : (
        <div
          onClick={() => void onCreateNewIncident(call)}
          className="call-notification-item d-flex flex-row justify-content-between align-items-center border-bottom py-1 px-2"
          style={{ cursor: 'pointer' }}
        >
          {content}
          <FaIcon icon="fa-light fa-plus" />
        </div>
      )}
    </div>
  );
}
